import { ActionPermission } from '../../constants';
import type { ActionPermissionType } from '../../types';

const UNCHECK_ACTION_DEPENDENCIES = {
  [ActionPermission.VIEW]: [
    ActionPermission.UPDATE,
    ActionPermission.CREATE,
    ActionPermission.STATUS,
    ActionPermission.DELETE,
  ],
  [ActionPermission.UPDATE]: [ActionPermission.CREATE],
  [ActionPermission.CREATE]: [],
  [ActionPermission.STATUS]: [],
  [ActionPermission.DELETE]: [],
};

export function autoUncheckAction(action: ActionPermissionType) {
  return UNCHECK_ACTION_DEPENDENCIES[action];
}
